import React from 'react';

const AccessDenied = () => (
  <div id="page">
    <h1>Opps!!!</h1>
  </div>
);

export default AccessDenied;
